import getCheckCompanyInfo from './getCheckCompanyInfo';
import getCompanyList from './getCompanyList';
import getOrgQuery from './getOrgQuery';
import create from './create';
import companyInfoPreTreated from './companyInfoPreTreated';
export default {
    getCheckCompanyInfo,
    getCompanyList,
    getOrgQuery,
    create,
    companyInfoPreTreated
};


// WEBPACK FOOTER //
// ./src/api/orgInfo/index.ts